import { render, staticRenderFns } from "./TableRowActions.vue?vue&type=template&id=3f897189&"
import script from "./TableRowActions.vue?vue&type=script&lang=js&"
export * from "./TableRowActions.vue?vue&type=script&lang=js&"
import style0 from "./TableRowActions.vue?vue&type=style&index=0&id=3f897189&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports